<template>
    <div style="height: 100%;">
        <van-nav-bar title="门店成绩单" left-text="返回" left-arrow @click-left="historyBack"/>
        <div style="width: 100%;padding-bottom: 10px;margin-top: 5px;text-align: center">
            <el-radio-group v-model="jxPosition" @change="activeChange" size="mini">
              <el-radio-button label="2">本月</el-radio-button>
              <el-radio-button label="3">上月</el-radio-button>
            </el-radio-group>
        </div>
        <el-table size="mini" :data="storeDailyPks" highlight-current-row height="calc(100% - 6rem)"
                    ref="table"  border :span-method="spanMethod">
                <el-table-column label="分组" width="50px" align="center"prop="groupname" fixed="left" :key="Math.random()"></el-table-column>
                <el-table-column label="门店名称" width="100px" align="center"prop="storename" fixed="left" :key="Math.random()"></el-table-column>
                <el-table-column label="实业绩" width="100px" align="center"prop="hairrealperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.hairrealperf/10)}}
                    </template>
                </el-table-column>
                <el-table-column label="美发业绩" width="100px" align="center"prop="hairdeptperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.hairdeptperf/10)}}
                    </template>
                </el-table-column>
                <el-table-column label="护理业绩" width="100px" align="center"prop="hlperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{parseInt(scope.row.hlperf)/10}}/{{percentgae(scope.row.hllv)}}
                    </template>
                </el-table-column>
                <el-table-column label="护理灯牌" width="100px" align="center"prop="hlperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{scope.row.hlcount}}/{{scope.row.hltotalnumber}}({{percentgae(scope.row.tplv)}})
                    </template>
                </el-table-column>
                <el-table-column label="新客成交" width="100px" align="center"prop="hlperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{scope.row.newcount}}/{{scope.row.skcount}}({{percentgae(scope.row.cjlv)}})
                    </template>
                </el-table-column>
                <el-table-column label="大项率" width="100px" align="center"prop="hlperf"  :key="Math.random()">
                    <template slot-scope="scope">
                        {{scope.row.dxcount}}/{{scope.row.haircount}}({{percentgae(scope.row.dxlv)}})
                    </template>
                </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                jxPosition:"2",
                storeDailyPks:[],
                storeid:localStorage.getItem("parentstoreid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
            }
        },
        created: function () {
            this.gethairreport();
        },
        methods: {
            percentgae(number){
                return Math.round(number*100)+"%"
            },
            spanMethod({ row, column, rowIndex, columnIndex }){
                if (columnIndex === 0) {
                    return this.getCellMerge(rowIndex);
                }
            },
            getCellMerge(rowIndex){
                let count=0;
                let index=0;
                let startIndex=-1;
                let groupid=this.storeDailyPks[rowIndex].groupid;
                for(let val of this.storeDailyPks) {
                    if (val.groupid == groupid) {
                        count = count + 1;
                        if (startIndex < 0) {
                            startIndex = index;
                        }
                    }
                    index++;
                }
                if(rowIndex==startIndex){
                    return {rowspan: count,colspan: 1};
                }
                else {
                    return {rowspan: 0, colspan: 0};
                }
            },
            activeChange(name){
                //console.log(name);
                if(name=="2"){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(name=="3"){
                    let dates=this.$lastMonth();
                    this.fromdate=dates[0];
                    this.todate=dates[1];
                }
                this.gethairreport();
            },
            gethairreport(){
                this.$post("hairmanager/gethairreport",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        this.storeDailyPks=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/hairstorereport.vue